import React, { ReactNode, useState } from "react";
import { Box, Text } from "@chakra-ui/react";
import { theme } from "src/styles/theme";

interface ITooltip {
  children: ReactNode;
  text: string;
  disabled?: boolean;
  isRight?: boolean;
}

const Tooltip = ({ children, text, disabled, isRight }: ITooltip) => {
  const [show, setShow] = useState(false);

  if (disabled) return <>{children}</>;

  return (
    <Box
      position="relative"
      display="flex"
      w="fit-content"
      onMouseEnter={() => setShow(true)}
      onMouseLeave={() => setShow(false)}
    >
      {children}

      {show && (
        <Box
          position="absolute"
          top="calc(100% - 35px)"
          left={isRight ? "calc(100% - 165px)" : "0px"}
          transform="translateX(10px)"
          background={theme.text}
          color="white"
          p="4px"
          borderRadius="8px"
          zIndex={1}
          fontSize="12px"
          width="max-content"
          maxW="200px"
          whiteSpace="normal"
          wordBreak="break-word"
        >
          <Text>{text}</Text>
        </Box>
      )}
    </Box>
  );
};

export default Tooltip;
